import {
  UPDATE_VIDEO_UPLOADER,
  UPDATE_VIDEO_RESPONSIBLE_USER,
  VIDEO_BOX_ERROR,
  VIDEO_BOX_HOME_REQUEST,
  VIDEO_BOX_REQUEST,
  VIDEO_BOX_RESET,
  VIDEO_BOX_SUCCESS,
  UPDATE_VIDEO_SAVED,
} from './actions';
import { RATE_VIDEO_SUCCESS } from 'components/video-player/rate-video/actions';

const initialState = {
  loading: true,
  video: null,
  error: null,
  videoUploader: null,
  videoResponsibleUser: null,
};

export const videoBoxReducer = (state = initialState, action) => {
  switch (action.type) {
    case VIDEO_BOX_HOME_REQUEST:
    case VIDEO_BOX_REQUEST:
      return initialState;

    case VIDEO_BOX_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };

    case UPDATE_VIDEO_UPLOADER:
      return {
        ...state,
        videoUploader: action.payload.videoUploader,
      };

    case UPDATE_VIDEO_RESPONSIBLE_USER:
      return {
        ...state,
        videoResponsibleUser: action.payload.responsibleUser,
      };

    case RATE_VIDEO_SUCCESS:
      return {
        ...state,
        video: {
          ...state.video,
          ratingAvg: action.payload.averageRating,
          userRating: action.payload.userRating,
        },
      };

    case UPDATE_VIDEO_SAVED:
      return {
        ...state,
        video: {
          ...state.video,
          saved: action.payload.saved,
        },
      };

    case VIDEO_BOX_RESET:
      return initialState;

    case VIDEO_BOX_ERROR:
      return {
        ...action.payload,
        loading: false,
        video: null,
      };

    default:
      return state;
  }
};
